/* 商品ページ：ギャラリー（サムネイル・矢印・スワイプ・枚数・キャプション）、拡大表示、数量、価格表示。
   元：catalog-product.js。写真・価格は Liquid が出力する #vc-page-data / #vc-variant-data から読む。
   変更点：数量の上限（2点）を撤廃、未登録の仕様欄は触らない。
   比較価格（取り消し線）と「残りわずか」は Liquid が種類ごとに判定した値（compare / low）だけを使う。 */
(() => {
  const root = document.getElementById("vc-product");
  if (!root) return;
  const page = JSON.parse(document.getElementById("vc-page-data").textContent);
  const data = JSON.parse(document.getElementById("vc-variant-data").textContent);
  const $ = (s) => root.querySelector(s);
  const all = (s) => [...root.querySelectorAll(s)];
  const photos = page.gallery || [];
  const image = $("#vc-main-photo");
  const dialog = document.getElementById("vc-lightbox");
  const QUANTITY_FALLBACK_MAX = 99;
  let index = 0;

  const resize = (url, width) => {
    const u = new URL(url, location.href);
    u.searchParams.set("width", width);
    return u.href;
  };

  function setPhoto(i) {
    if (!photos.length || !image) return;
    index = (i + photos.length) % photos.length;
    const shot = photos[index];
    image.src = resize(shot.url, 1200);
    image.srcset = [480, 800, 1200].map((w) => `${resize(shot.url, w)} ${w}w`).join(", ");
    image.alt = `${page.title} — ${shot.caption}`;
    if (shot.width) image.width = shot.width;
    if (shot.height) image.height = shot.height;
    const caption = $("#vc-caption");
    if (caption) caption.textContent = shot.caption;
    const count = $("#vc-count");
    if (count) count.textContent = `${String(index + 1).padStart(2, "0")} / ${String(photos.length).padStart(2, "0")}`;
    all("[data-vc-photo]").forEach((b) => b.setAttribute("aria-pressed", String(Number(b.dataset.vcPhoto) === index)));
    syncLowStock();
  }

  // 「残りわずか」は選んでいる種類の1枚目（その種類の最初の写真）を表示しているときだけ
  function syncLowStock() {
    const badge = $("[data-sb-low-stock]");
    if (!badge) return;
    const variant = current();
    const first = variant && variant.media >= 0 ? variant.media : 0;
    badge.hidden = !(variant && variant.low && index === first);
  }

  function showPhoto(i) {
    const shot = photos[i];
    if (!shot || !dialog) return;
    const el = document.getElementById("vc-lightbox-image");
    el.src = resize(shot.url, 2000);
    el.alt = `${page.title} — ${shot.caption}`;
    document.getElementById("vc-lightbox-caption").textContent = shot.caption;
    dialog.showModal();
    document.body.classList.add("modal-open");
  }

  root.addEventListener("click", (e) => {
    const thumb = e.target.closest("[data-vc-photo]");
    const arrow = e.target.closest("[data-vc-step]");
    if (thumb) setPhoto(Number(thumb.dataset.vcPhoto));
    if (arrow) setPhoto(index + Number(arrow.dataset.vcStep));
    if (e.target.closest("[data-vc-zoom]")) showPhoto(index);
  });

  if (dialog) {
    dialog.addEventListener("click", (e) => {
      if (e.target === dialog || e.target.closest("[data-vc-close]")) dialog.close();
    });
    dialog.addEventListener("close", () => document.body.classList.remove("modal-open"));
  }

  const stage = $("[data-vc-stage]");
  let startX = null;
  stage?.addEventListener("pointerdown", (e) => { startX = e.clientX; });
  stage?.addEventListener("pointerup", (e) => {
    if (startX !== null && Math.abs(e.clientX - startX) > 60) setPhoto(index + (e.clientX < startX ? 1 : -1));
    startX = null;
  });
  stage?.addEventListener("pointercancel", () => { startX = null; });

  const quantity = $("#vc-quantity");
  const quantityButtons = all("[data-vc-qty-step]");
  function syncQuantity(normalize = false) {
    if (!quantity) return;
    const min = Number(quantity.min) || 1;
    const max = Number(quantity.max) || QUANTITY_FALLBACK_MAX;
    if (normalize) quantity.value = String(Math.max(min, Math.min(max, Math.trunc(Number(quantity.value) || min))));
    const value = Number(quantity.value);
    const sticky = $("[data-vc-sticky-quantity]");
    if (sticky) sticky.textContent = String(value);
    quantityButtons.forEach((b) => { b.disabled = Number(b.dataset.vcQtyStep) < 0 ? value <= min : value >= max; });
  }
  quantityButtons.forEach((button) => button.addEventListener("click", () => {
    syncQuantity(true);
    quantity.value = String(Number(quantity.value) + Number(button.dataset.vcQtyStep));
    syncQuantity(true);
    quantity.dispatchEvent(new Event("change", { bubbles: true }));
  }));
  quantity?.addEventListener("input", () => syncQuantity(true));
  quantity?.addEventListener("change", () => syncQuantity(true));
  syncQuantity(true);

  const select = $("#vc-variant");
  const money = (value) => new Intl.NumberFormat("ja-JP", { style: "currency", currency: data.currency }).format(value / 100);
  const current = () => data.variants.find((v) => String(v.id) === select?.value) || data.variants[0];

  function updateVariant() {
    const variant = current();
    if (!variant) return;
    const hasCompare = variant.compare !== null && variant.compare > variant.price;
    all("[data-sb-price]").forEach((el) => {
      el.classList.toggle("is-compare", hasCompare);
      el.querySelectorAll("[data-sb-price-label], [data-sb-price-sr]").forEach((x) => { x.hidden = !hasCompare; });
      const compare = el.querySelector("[data-sb-price-compare]");
      if (compare) {
        compare.hidden = !hasCompare;
        const sr = compare.querySelector(".sb-sr");
        compare.textContent = hasCompare ? money(variant.compare) : "";
        if (sr) compare.prepend(sr);
      }
      const value = el.querySelector("[data-sb-price-value]");
      if (value) value.textContent = money(variant.price);
    });
    syncLowStock();
    if (variant.dims) all("[data-vc-size]").forEach((el) => { el.textContent = variant.dims; });
    if (variant.weight) all("[data-vc-weight]").forEach((el) => { el.textContent = variant.weight; });
    all("[data-vc-add]").forEach((button) => {
      button.disabled = !variant.available;
      const label = variant.available
        ? (button.classList.contains("vc-sticky-add") ? data.labels.add_short : data.labels.add)
        : data.labels.sold_out;
      button.textContent = label;
    });
  }

  // サイズの切り替え：種類を選び直し、その種類の写真（商品だけの写真）を表示する
  all("[data-vc-variant]").forEach((button) => button.addEventListener("click", () => {
    if (!select) return;
    select.value = button.dataset.vcVariant;
    all("[data-vc-variant]").forEach((b) => b.setAttribute("aria-pressed", String(b === button)));
    updateVariant();
    const variant = current();
    if (variant && variant.media >= 0) setPhoto(variant.media);
    const url = new URL(location.href);
    url.searchParams.set("variant", select.value);
    history.replaceState(null, "", url);
  }));

  $("#vc-form")?.addEventListener("submit", (e) => {
    syncQuantity(true);
    if (!current()?.available) e.preventDefault();
  });

  if (photos.length) setPhoto(Math.max(0, current()?.media ?? 0));
  updateVariant();
})();
